import React from 'react'
import { IconView, IconViewOff } from './UiIcons'
import styled from 'styled-components'

const TogglePassword = styled.span`
    right: 10px !important;
    cursor: pointer;
`

type IUiTogglePassword = {
	showPassword: boolean
	setShowPassword: React.Dispatch<React.SetStateAction<boolean>>
}

export const UiTogglePassword = ({
	showPassword,
	setShowPassword
}: IUiTogglePassword) => {

	return (
		<TogglePassword
			className="text-body field-icon toggle-password position-absolute top-50 end-0 fs-20 translate-middle-y"
			onClick={(event) => {
				setShowPassword(prevVal => !prevVal)
			}}
		>
			{!showPassword ? (
				<IconView size={20}/>
			) : (
				<IconViewOff size={20}/>
			)}
		</TogglePassword>
	)
}